<template>
  <b-row>
    <b-col cols="12">
      <div
        v-if="error"
        class="alert alert-dismissible alert-danger"
        role="alert">
        <span v-html="error"></span>
      </div>
      <div
        v-if="deleteError"
        class="alert alert-dismissible alert-danger"
        role="alert">
        <span
          class="fa fa-exclamation-triangle"
          aria-hidden="true"></span> {{ deleteError }}
      </div>
    </b-col>
    <b-col cols="12">
      <router-link :to="{ name: 'DatabaseConnectionList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
    </b-col>
    <b-col cols="12">
      <div class="card">
        <template v-if="isLoading || deleteLoading">
          <Loader></Loader>
        </template>
        <template v-else>
          <div class="card-body">
            <DatabaseConnectionForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </div>
        </template>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DatabaseConnectionForm from './Form.vue'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    Loader,
    DatabaseConnectionForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'databaseconnection/update/isLoading',
      error: 'databaseconnection/update/error',
      deleteError: 'databaseconnection/del/error',
      deleteLoading: 'databaseconnection/del/isLoading',
      created: 'databaseconnection/create/created',
      deleted: 'databaseconnection/del/deleted',
      retrieved: 'databaseconnection/update/retrieved',
      updated: 'databaseconnection/update/updated',
      violations: 'databaseconnection/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'DatabaseConnectionList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'databaseconnection/create/reset',
      deleteItem: 'databaseconnection/del/del',
      delReset: 'databaseconnection/del/reset',
      retrieve: 'databaseconnection/update/retrieve',
      updateReset: 'databaseconnection/update/reset',
      update: 'databaseconnection/update/update',
      updateRetrieved: 'databaseconnection/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this databaseconnection ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.port) {
        this.retrieved.port = parseInt(this.retrieved.port)
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
